module.exports = __webpack_public_path__ + "static/img/nume__ro-7.b42a48d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/old/nume__ro-7.jpg
// module id = GPhP
// module chunks = 0